import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import ControlPanel from "./ControlPanel";
// import ObsPanel from "./ObsPanel";
import CommentPicker from "./CommentPicker";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Root = styled("div")(({ theme }) => ({
  flexGrow: 1,
  backgroundColor: theme.palette.background.paper,
}));

export default function SimpleTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Root>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          indicatorColor="secondary"
        >
          <Tab label="Main" {...a11yProps(0)} />
          {/* <Tab label="OBS" {...a11yProps(1)} /> */}
          <Tab label="Comment Picker" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <ControlPanel />
      </TabPanel>
      {/* <TabPanel value={value} index={1}> */}
      {/* <ObsPanel /> */}
      {/* </TabPanel> */}
      <TabPanel value={value} index={1}>
        <CommentPicker />
      </TabPanel>
    </Root>
  );
}
